import { __assign } from "tslib";
import { connect } from 'react-redux';
import { changeHandoffHoveredItem, changeHandoffSelectedItem, } from '../../actionCreators';
import Element from '../../components/handoff/Element';
import { getArtboardSize, getElementClassName, getPixelRatio, getZoomScale, isElementHoverable, isElementHovered, isElementSelectable, isElementSelected, showGuides, } from '../../selectors/handoff';
function mapStateToProps(state, _a) {
    var id = _a.id;
    var artboardSize = getArtboardSize(state);
    return {
        artboardWidth: artboardSize[0],
        artboardHeight: artboardSize[1],
        isSlice: getElementClassName(state, id) === 'Slice',
        isSelected: isElementSelected(state, id),
        isHovered: isElementHovered(state, id),
        isSelectable: isElementSelectable(state, id),
        isHoverable: isElementHoverable(state, id),
        showGuides: showGuides(state, id),
        zoomScale: getZoomScale(state),
        pixelRatio: getPixelRatio(state),
    };
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var id = ownProps.id;
    var isHoverable = stateProps.isHoverable;
    var actions = {
        onClick: function (e) {
            // stop this propagating up and deselecting thr element we just clicked!
            e.stopPropagation();
            dispatch(changeHandoffSelectedItem(id));
        },
        onMouseOver: function () {
            if (isHoverable) {
                dispatch(changeHandoffHoveredItem(id));
            }
        },
        onMouseOut: function () {
            dispatch(changeHandoffHoveredItem(null));
        },
    };
    return __assign(__assign(__assign({}, ownProps), actions), stateProps);
}
export default connect(mapStateToProps, null, mergeProps)(Element);
